module.exports = __webpack_public_path__ + "static/bg_lines-f1c713a63e2e3502aa2260765a61e4de.png";